<template>
  <div>
    <MassAgentUpdateDialog 
      v-if="$store.state.massUpdateDialog"
      :userId="regionalId"
      :managerName="regionalName"
      :managerLevel="'regional'"
    />

    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->

      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9">
              <v-btn
                small
                color="info"
                class="mr-4"
                @click="
                  [
                    $router.push({
                      name: 'AdministratorUsersRegionalManagersCreate',
                    }),
                    showDialog(),
                  ]
                "
              >
                <v-icon small left>mdi-plus</v-icon>
                {{ $t("newRegionalManager") }}
              </v-btn>
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :items-per-page="10"
          class="elevation-1 mb-3"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id="{ item }">
            <v-btn @click="$copy(item.id)" x-small>{{ item.id }}</v-btn>
          </template>
          <template v-slot:item.name_regional="{ item }">
            <a
              class="orange--text"
              @click="
                $profile.showProfileDrawer(
                  item.id,
                  '/administrator/regionals/getRegional'
                )
              "
            >
              <v-icon color="orange" small>mdi-account-tie</v-icon>
              {{ item.name_regional }}
            </a>
            <v-chip
              v-if="item.comissao_online"
              color="primary"
              small
              class="ml-1"
            >
              {{ $t("affiliate") }}
            </v-chip>
          </template>

          <template v-slot:item.status="{ item }">
            <v-icon :color="handleColorStatus(item.status)" size="16">
              mdi-circle
            </v-icon>
          </template>

          <template v-slot:item.data_cadastro="{ item }">
            <span class="caption">{{ item.data_cadastro }}</span>
          </template>

          <template v-slot:item.action="{ item }">
            <v-btn-toggle dense>
              <v-btn
                :title="$t('view')"
                small
                @click="
                  $profile.showProfileDrawer(
                    item.id,
                    '/administrator/regionals/getRegional'
                  )
                "
              >
                <v-icon>mdi-account-tie</v-icon>
              </v-btn>
              <v-btn
                :title="$t('edit')"
                small
                @click="
                  [
                    $router.push({
                      name: 'AdministratorUsersRegionalManagersEdit',
                      params: { id: item.id },
                    }),
                    showDialog(),
                  ]
                "
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    :title="$t('massAgentsActivationTitle')"
                    small
                    @click="openMassUpdateDialog(item)"
                  >
                    <v-icon>mdi-account-convert</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("massAgentsUpdateTitle") }} </span>
              </v-tooltip>


              <MenuDropdownStatusUser
                :id_user="item.id"
                :status_user="item.status"
              />
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <router-view></router-view>
  </div>
</template>
<script>
import MenuDropdownStatusUser from "@/components/administrator/menu/dropdownStatusUser.vue";
import HeaderPrint from "@/components/common/header-print";
import MassAgentUpdateDialog from "@/components/common/dialog/dialogMassAgentUpdate.vue";

export default {
  components: { MenuDropdownStatusUser, HeaderPrint, MassAgentUpdateDialog },
  name: "administrator-users-regional-managers-list",
  data: () => ({
    data: [],
    search: "",
    regionalId: 0,
    regionalName: "",
  }),
  computed: {
    headers() {
      return [
        { text: "Id", value: "id" },
        { text: this.$t("status"), value: "status" },
        { text: this.$t("name"), value: "name_regional" },
        { text: this.$t("login"), value: "login_regional" },
        { text: this.$t("createdIn"), value: "data_cadastro" },
        {
          text: this.$t("actions"),
          value: "action",
          align: "center d-print-none",
        },
      ];
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
    // 2. Setup Filters
    status() {
      return this.$store.state.filters.selectStatus.status;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },
  watch: {
    refresh(val) {
      val && this.getRegionalsList();
      this.$store.commit("setRefresh", false);
    },
    // 3. Setup Filters
    saveFilters(val) {
      val && this.getRegionalsList();
    },
  },
  methods: {
    openMassUpdateDialog(item) {
      this.regionalId = item.id;
      this.regionalName = item.name_regional;
      this.$store.commit("massUpdateDialog", true);
    },
    resetPage() {
      this.search = "";
    },
    async getRegionalsList() {
      this.resetPage();
      const body = { status: this.status };
      const response = await this.$request.post(
        "administrator/regionals/list",
        body
      );

      this.data = response.length == 0 ? [] : response.dados;

      this.data = this.data.map((item) => {
        item.data_cadastro = new Date(
          item.data_cadastro.replace(" ", "T")
        ).toLocaleString();
        return item;
      });
    },

    // Show Dialog
    showDialog() {
      this.$store.commit("showDialog", true);
    },
    // handle color status
    handleColorStatus(status) {
      if (status == 0) return "red";
      if (status == 1) return "green";
      if (status == 2) return "orange";
    },
  },
};
</script>
